import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, ModuleGuard } from '../../../core/auth';
import {
  CategoryListComponent,
  DocumentListComponent,
  AccessHistoryListComponent,
} from './components';

const routes: Routes = [
  {
    path: 'categories',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'accessDocumentCategory' },
    component: CategoryListComponent,
  },
  {
    path: 'library',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'accessDocument' },
    component: DocumentListComponent,
  },
  {
    path: 'access-history',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'canViewDocumentAccessHistory' },
    component: AccessHistoryListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DocumentsManagementRoutingModule {}
